<template>
  <div
    v-if="showLoadingState < 2"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="academyUserProfile"
    class="m-edition-billing-academy-users-profile-info"
  >
    <div class="m-edition-billing-academy-users-profile-info-body">
      <div class="display-flex-row-center profile-info-user">
        <AtomAvatarSecondary
          avatar-class="xlarge profile-info-user-avatar"
          :user-image="perfil.usuario.avatar"
        />
        <span class="display-flex-column font-weight-light justify-content-center profile-info-user-email">
          <span
            v-if="perfil.usuario.persona && perfil.usuario.persona.razon_social"
            class="font-size-large"
          >
            <b>{{ perfil.usuario.persona.razon_social }}</b>
          </span>
          <span :class="getUserGlobalState()">
            {{ perfil.usuario.email }}
          </span>
          <span class="font-size-small text-color-black-55">
            {{ $t('mEditionBillingAcademyUsersProfile.messages.activeSince') }}
            <span class="text-transform-capitalize">
              {{ $moment.parseZone(perfil.actores[0].fecha_alta).format('D MMMM YYYY') }}
            </span>
          </span>
          <span class="font-size-small text-color-black-55">
            {{ $t('mEditionBillingAcademyUsersProfile.messages.lastLogin') }}
            <span v-if="tracking && tracking.ultimo_login && tracking.ultimo_login.ultimo_login">
              {{ $moment.parseZone(tracking.ultimo_login.ultimo_login).format('D MMMM YYYY HH:mm') }}
            </span>
            <span v-else>
              {{ `(${$t('mEditionBillingAcademyUsersProfile.messages.noTracking')})` }}
            </span>
          </span>
        </span>
      </div>

      <div class="profile-info-persona">
        <p class="display-flex-row">
          <span class="margin-right-small profile-info-persona-icon">
            <i class="fas fa-map-marker-alt"></i>
          </span>
          <span
            v-if="perfil.usuario.persona && perfil.usuario.persona.domicilio"
            class="profile-info-persona-text"
          >
           <span> {{ perfil.usuario.persona.domicilio.provincia.pais.nombre }} </span>
           <span>, {{ perfil.usuario.persona.domicilio.provincia.nombre }} </span>
           <span v-if="perfil.usuario.persona.domicilio.localidad">
              , {{ perfil.usuario.persona.domicilio.localidad }}
           </span>
           <span v-if="perfil.usuario.persona.domicilio.codigo_postal">
              , {{ perfil.usuario.persona.domicilio.codigo_postal }}
           </span>
           <span v-if="perfil.usuario.persona.domicilio.linea1">
              , {{ perfil.usuario.persona.domicilio.linea1 }} </span>
           <span v-if="perfil.usuario.persona.domicilio.linea2">
              {{ perfil.usuario.persona.domicilio.linea2 }} </span>
          </span>
          <span
            v-else
            class="profile-info-persona-text"
          >
            {{ `(${$t('mEditionBillingAcademyUsersProfile.messages.noLocation')})` }}
          </span>
        </p>

        <p class="display-flex-row">
          <span class="margin-right-small profile-info-persona-icon">
            <i class="fas fa-balance-scale"></i>
          </span>
          <span
            v-if="perfil.usuario.persona && perfil.usuario.persona.documento"
            class="profile-info-persona-text"
          >
            {{ $filters.getPersonValue(+perfil.usuario.persona.fisica, 'name') }}
          <span v-if="perfil.usuario.persona.documento && perfil.usuario.persona.documento.tipo.id_documento_tipo !== 1 &&  perfil.usuario.persona.documento.tipo.nombre !== 'ID' &&  perfil.usuario.persona.documento.numero">
            &bull;
            {{ perfil.usuario.persona.documento.tipo.nombre }}
            {{ perfil.usuario.persona.documento.numero }}
          </span>
          </span>
          <span
            v-else
            class="profile-info-persona-text"
          >
            {{ `(${$t('mEditionBillingAcademyUsersProfile.messages.noLegal')})` }}
          </span>
        </p>

        <p class="display-flex-row">
          <span class="margin-right-small profile-info-persona-icon">
            <i class="fas fa-mobile-alt"></i>
          </span>
          <span
            v-if="perfil.usuario.persona"
            class="profile-info-persona-text"
          >
            {{ $t('mEditionBillingAcademyUsersProfile.messages.phone') }}
            {{ perfil.usuario.persona.telefono || `(${$t('mEditionBillingAcademyUsersProfile.messages.noNumber')})` }}
            &bull;
            {{ $t('mEditionBillingAcademyUsersProfile.messages.mobile') }}
            {{ perfil.usuario.persona.movil || `(${$t('mEditionBillingAcademyUsersProfile.messages.noNumber')})` }}
          </span>
          <span
            v-else
            class="profile-info-persona-text"
          >
            {{ `(${$t('mEditionBillingAcademyUsersProfile.messages.noContact')})` }}
          </span>
        </p>
      </div>

      <div class="profile-info-roles">
        <h4>{{ $t('mEditionBillingAcademyUsersProfile.title') }}</h4>
        <ul class="a-list-clean margin-bottom-zero width-100-pr">
          <li
            v-for="(actor, index) in perfil.actores"
            :key="index"
            class="display-flex-row-center font-weight-light margin-bottom-medium"
          >
            <span>
              {{ $filters.getActorValue(actor.tipo, 'name') }}
            </span>
            <span class="margin-left-auto">
              <span
              v-if="actor.habilitado"
              class="font-weight-bold text-color-success"
              >
                Habilitado
              </span>
              <span
                v-else
                class="font-weight-bold text-color-danger"
              >
                Deshablida
              </span>
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div
      v-if="perfil.actores.some(actor => actor.tipo === 0)"
      class="m-edition-billing-academy-users-profile-info-body">
      <h4>
        {{ `${$t('mEditionBillingAcademyUsersProfile.titleAssets')}` }}
      </h4>
        <ul class="a-list-clean margin-bottom-zero width-100-pr">
          <li
          v-for="(proyecto, indexP) in proyectos"
          :key="indexP"
          >
            <p>
              <span class="info-icon info-icon-billing">
                <i class="fas fa-folder-open"></i>
              </span>
              <span>
                {{ proyecto.titulo + ' - '}}
              </span>
              <span
              v-if="proyecto.inscripcion_activa"
              class="font-weight-bold info-text-highlighted-success"
              >
                Activa
              </span>
              <span
                v-else
                class="font-weight-bold info-text-highlighted-danger"
              >
                Inactiva
              </span>
              <span>
                {{ $moment.parseZone(proyecto.fecha_inscripcion).format('D MMMM, YYYY') }}
              </span>
              <span
                v-if="getTrackingProyecto(proyecto)"
                class="font-size-small text-color-black-55"
              >
                &bull;
                {{ `${$t('mEditionBillingAcademyUsersProfile.messages.progress')} ${getTrackingProyecto(proyecto).porcentaje}%` }}
                <span v-if="getTrackingProyecto(proyecto).nodos_activos">
                  {{ `(${$t('mEditionBillingAcademyUsersProfile.messages.progressActive')} ${getTrackingProyecto(proyecto).porcentaje_activos}%)` }}
                </span>
                <span v-if="getTrackingProyecto(proyecto).ultimo_acceso">
                  &bull;
                  {{ `${$t('mEditionBillingAcademyUsersProfile.messages.lastAccess')} ${$moment.parseZone(getTrackingProyecto(proyecto).ultimo_acceso).format('D MMM YYYY HH:mm')}` }}
                </span>
              </span>
            </p>
          </li>
          <li
          v-for="(mapa, indexM) in mapas"
          :key="indexM + proyectos.length"
          >
            <p>
              <span class="info-icon info-icon-map">
                <i class="fas fa-map-marker-alt"></i>
              </span>
              <span>
                {{ mapa.titulo + ' - '}}
              </span>
              <span
              v-if="mapa.inscripcion_activa"
              class="font-weight-bold info-text-highlighted-success"
              >
                Activa
              </span>
              <span
                v-else
                class="font-weight-bold info-text-highlighted-danger"
              >
                Inactiva
              </span>
              <span>
                {{ $moment.parseZone(mapa.fecha_inscripcion).format('D MMMM, YYYY') }}
              </span>
              <span
                v-if="getTrackingProyecto(mapa)"
                class="font-size-small text-color-black-55"
              >
                &bull;
                {{ `${$t('mEditionBillingAcademyUsersProfile.messages.progress')} ${getTrackingProyecto(mapa).porcentaje}%` }}
                <span v-if="getTrackingProyecto(mapa).nodos_activos">
                  {{ `(${$t('mEditionBillingAcademyUsersProfile.messages.progressActive')} ${getTrackingProyecto(mapa).porcentaje_activos}%)` }}
                </span>
                <span v-if="getTrackingProyecto(mapa).ultimo_acceso">
                  &bull;
                  {{ `${$t('mEditionBillingAcademyUsersProfile.messages.lastAccess')} ${$moment.parseZone(getTrackingProyecto(mapa).ultimo_acceso).format('D MMM YYYY HH:mm')}` }}
                </span>
              </span>
            </p>
          </li>
        </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingAcademyUsersProfile',

  data () {
    return {
      perfil: {},
      proyectos: [],
      mapas: [],
      showLoadingState: 0,
      tracking: null,
      trackingPorProyecto: {}
    }
  },

  created () {
    this.readAcademiaPerfilActor()
    this.readTrackingResumen()
  },

  methods: {
    getTrackingProyecto (proyecto) {
      const id = proyecto.id_proyecto || proyecto.id
      return id ? this.trackingPorProyecto[id] : null
    },

    readTrackingResumen () {
      this.$services.read('tracking', 'readTrackingUsuarioResumen', {}, [this.$route.params.thirdid])
        .then(response => {
          this.tracking = response.data
          // Una inscripcion por proyecto: las vigentes vienen primero y tienen prioridad
          this.trackingPorProyecto = (response.data.inscripciones || []).reduce((mapa, inscripcion) => {
            if (!mapa[inscripcion.proyecto]) {
              mapa[inscripcion.proyecto] = inscripcion
            }
            return mapa
          }, {})
        })
        .catch(error => {
          console.log(error)
        })
    },

    getUserGlobalState () {
      if (this.perfil.actores.find(actor => actor.habilitado === 1)) {
        return 'font-weight-bold text-color-success'
      } else {
        return 'font-weight-bold text-color-danger'
      }
    },

    readAcademiaPerfilActor () {
      // TODO: Modificar nombre de endpoint desde BE y FE
      this.$services.read('academia', 'readAcademiaPerfilActor', {}, [this.$route.params.subid, this.$route.params.thirdid])
        .then(response => {
          this.perfil = Object.assign({}, response.data)
          this.perfil.actores.sort((a, b) => {
            return Date.parse(a.fecha_alta) - Date.parse(b.fecha_alta)
          })
          this.showLoadingState++
          this.readProyectos()
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readProyectos () {
      this.$services.read('academia', 'readProyectosAcademia', {}, [this.$route.params.subid, this.perfil.actores.find(a => { return a.tipo === 0 }).id])
        .then(response => {
          this.proyectos = response.data.filter(p => { return p.tipo === 0 })
          this.mapas = response.data.filter(m => { return m.tipo === 1 })
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    }
  }
}
</script>
